import { render } from "./audioPlayer.vue?vue&type=template&id=6ee56844&scoped=true&ts=true"
import script from "./audioPlayer.vue?vue&type=script&lang=ts"
export * from "./audioPlayer.vue?vue&type=script&lang=ts"

import "./audioPlayer.vue?vue&type=style&index=0&id=6ee56844&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee56844"]])

export default __exports__